import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/workspace/artifacts/legible-web/src/app/demo/DemoClient.tsx");
